import { Link } from 'react-router-dom';
import { AppRoutes } from 'router/routes';

function WrongWay(): JSX.Element {
  return (
    <div style={{ margin: '150px 0', textAlign: 'center' }}>
      <h1>404 Страница не найдена</h1>
      <br />
      <Link to={AppRoutes.Main.path}>На Главную</Link>
    </div>
  );
}

export default WrongWay;
